import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import CreateMarket from './components/CreateMarket';
import FutrBetArchitecture from './components/FutrBetArchitecture';
import FastFilesLanding from './components/FastFilesLanding';
import FastFilesDashboard from './components/FastFilesDashboard';
import ShareFiles from './components/ShareFiles';
import ArchitectureViewResponsive from './components/ArchitectureViewResponsive';
import InteractiveArchitectureExplorer from './components/InteractiveArchitectureExplorer';
import Changelog from './components/Changelog';
import AdminTaskFlow from './components/AdminTaskFlow';
import AdminLayout from './components/admin/AdminLayout';
import AdminLogin from './components/admin/AdminLogin';
import AdminDashboard from './components/admin/AdminDashboard';
import D1TestPanel from './components/D1TestPanel';
import MarketResolutionTest from './components/tests/MarketResolutionTest';
import BettingFlowTest from './components/tests/BettingFlowTest';
import BettingFlowVisual from './components/BettingFlowVisual';
import TestDashboard from './components/TestDashboard';
import ClaudeAgentBuilder from './components/ClaudeAgentBuilder';
import LiveBettingFlow from './components/LiveBettingFlow';
import LiveBettingFlowFixed from './components/LiveBettingFlowFixed';
import EngineerBettingFlow from './components/EngineerBettingFlow';
import WorkingBettingFlow from './components/WorkingBettingFlow';
import SystemVisualizer from './components/SystemVisualizer';
import AuthDissection from './components/AuthDissection';
import UltraAuthExperience from './components/UltraAuthExperience';
import OTPGenerator from './components/OTPGenerator';
import OTPStorage from './components/OTPStorage';
import OTPVerification from './components/OTPVerification';
import OTPMarkUsed from './components/OTPMarkUsed';
import OTPEmailSender from './components/OTPEmailSender';
import OTPEmailFormatter from './components/OTPEmailFormatter';
import RealEmailSender from './components/RealEmailSender';
import EmailStatusTracker from './components/EmailStatusTracker';
import WebhookEventViewer from './components/WebhookEventViewer';
import OTPLoginFlow from './components/OTPLoginFlow';
import PlaceBetEngineer from './components/PlaceBetEngineer';
import Philosophy from './components/Philosophy';
import Showcase from './components/Showcase';
import PasswordReset from './components/PasswordReset';
import ChatTrainingDashboard from './components/ChatTrainingDashboard';
import EngineeringAssistant from './components/EngineeringAssistant';
import { EmailFeedbackTest } from './components/EmailFeedbackTest';
import { PuppeteerTestFlow } from './components/PuppeteerTestFlow';
import { TestResultsGallery } from './components/TestResultsGallery';
import SlackTestPretty from './pages/SlackTestPretty';
import SlackTestIterableV1 from './pages/SlackTestIterableV1';
import TaskTapFlow from './pages/TaskTapFlow';
import TaskTapDashboard from './pages/TaskTapDashboard';
import TaskTapPitch from './pages/TaskTapPitch';
import TaskTap from './pages/TaskTap';
import DollarStartClub from './pages/DollarStartClub';
import TaskTapVisualFlow from './pages/TaskTapVisualFlow';
import VoiceSetup from './pages/VoiceSetup';
import VoiceEngineer from './pages/VoiceEngineer';
import VoicePoC from './pages/VoicePoC';
import HookMachinePage from './pages/HookMachine';
import Puppeteer from './pages/Puppeteer';
import SlackExplorer from './components/SlackExplorer';
import ApprovalTest from './components/ApprovalTest';
import AIDecisionRequest from './components/AIDecisionRequest';
import ApprovalDashboard from './components/ApprovalDashboard';
import SlackTester from './components/SlackTester';
import SlackApproval from './components/SlackApproval';
import BugsAndIdeas from './components/BugsAndIdeas';
import SlackApprovalHandler from './pages/SlackApprovalHandler';
import TaskTapHandler from './pages/TaskTapHandler';
import TaskTapRecoverable from './pages/TaskTapRecoverable';
import TaskTapLiveDemo from './pages/TaskTapLiveDemo';
import TaskTapSources from './pages/TaskTapSources';

function App() {
  return (
    <Router>
      <EngineeringAssistant />
      <BugsAndIdeas />
      <Routes>
        <Route path="/" element={<CreateMarket />} />
        <Route path="/markets" element={<CreateMarket />} />
        <Route path="/market/:slug" element={<CreateMarket />} />
        <Route path="/portfolio" element={<CreateMarket />} />
        <Route path="/architecture" element={<FutrBetArchitecture />} />
        <Route path="/leaderboard" element={<div className="min-h-screen flex items-center justify-center"><h1 className="text-3xl">Leaderboard Coming Soon</h1></div>} />
        <Route path="/help" element={<div className="min-h-screen flex items-center justify-center"><h1 className="text-3xl">Help Center Coming Soon</h1></div>} />
        <Route path="/changelog" element={<Changelog />} />
        <Route path="/admin-tasks" element={<AdminTaskFlow />} />
        <Route path="/d1-test" element={<D1TestPanel />} />
        <Route path="/test/resolution" element={<MarketResolutionTest />} />
        <Route path="/test/betting" element={<BettingFlowTest />} />
        <Route path="/betting-flow" element={<BettingFlowVisual />} />
        <Route path="/test-dashboard" element={<TestDashboard />} />
        <Route path="/agent-builder" element={<ClaudeAgentBuilder />} />
        <Route path="/live-betting" element={<LiveBettingFlow />} />
        <Route path="/live-betting-fixed" element={<LiveBettingFlowFixed />} />
        <Route path="/engineer-flow" element={<EngineerBettingFlow />} />
        <Route path="/working-flow" element={<WorkingBettingFlow />} />
        <Route path="/system" element={<SystemVisualizer />} />
        <Route path="/auth" element={<AuthDissection />} />
        <Route path="/ultra-auth" element={<UltraAuthExperience />} />
        <Route path="/otp" element={<OTPGenerator />} />
        <Route path="/otp-storage" element={<OTPStorage />} />
        <Route path="/otp-verify" element={<OTPVerification />} />
        <Route path="/otp-mark-used" element={<OTPMarkUsed />} />
        <Route path="/otp-email" element={<OTPEmailSender />} />
        <Route path="/otp-format" element={<OTPEmailFormatter />} />
        <Route path="/send-real-email" element={<RealEmailSender />} />
        <Route path="/email-tracker" element={<EmailStatusTracker />} />
        <Route path="/webhook-viewer" element={<WebhookEventViewer />} />
        <Route path="/otp-login" element={<OTPLoginFlow />} />
        <Route path="/bet-engineer" element={<PlaceBetEngineer />} />
        <Route path="/philosophy" element={<Philosophy />} />
        <Route path="/showcase" element={<Showcase />} />
        <Route path="/password-reset" element={<PasswordReset />} />
        <Route path="/training" element={<ChatTrainingDashboard />} />
        <Route path="/email-test" element={<EmailFeedbackTest />} />
        <Route path="/test-flow" element={<PuppeteerTestFlow />} />
        <Route path="/test-results" element={<TestResultsGallery />} />
        <Route path="/slack-test-pretty" element={<SlackTestPretty />} />
        <Route path="/slack-test" element={<SlackTestIterableV1 />} />
        <Route path="/tasktap" element={<TaskTap />} />
        <Route path="/tasktap-flow" element={<TaskTapFlow />} />
        <Route path="/tasktap/visual" element={<TaskTapVisualFlow />} />
        <Route path="/tasktap/dashboard/:userId/*" element={<TaskTapDashboard />} />
        <Route path="/tasktap/pitch" element={<TaskTapPitch />} />
        <Route path="/dollarstartclub" element={<DollarStartClub />} />
        <Route path="/voice-setup" element={<VoiceSetup />} />
        <Route path="/voice-engineer" element={<VoiceEngineer />} />
        <Route path="/voice-poc" element={<VoicePoC />} />
        <Route path="/hook-machine" element={<HookMachinePage />} />
        <Route path="/puppeteer" element={<Puppeteer />} />
        <Route path="/slack-explorer" element={<SlackExplorer />} />
        <Route path="/approval-test" element={<ApprovalTest />} />
        <Route path="/ai-decision" element={<AIDecisionRequest />} />
        <Route path="/approval-dashboard" element={<ApprovalDashboard />} />
        <Route path="/slack-test-old" element={<SlackTester />} />
        <Route path="/slack-approval" element={<SlackApproval />} />
        <Route path="/slack/approve" element={<SlackApprovalHandler />} />
        <Route path="/tasktap/handler" element={<TaskTapHandler />} />
        <Route path="/tasktap/recoverable" element={<TaskTapRecoverable />} />
        <Route path="/tasktap/demo" element={<TaskTapLiveDemo />} />
        <Route path="/tasktap/sources" element={<TaskTapSources />} />

        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="login" element={<AdminLogin />} />
          <Route path="markets" element={<div className="text-white">Markets Management (Coming Soon)</div>} />
          <Route path="users" element={<div className="text-white">Users Management (Coming Soon)</div>} />
          <Route path="stats" element={<div className="text-white">Advanced Statistics (Coming Soon)</div>} />
          <Route path="settings" element={<div className="text-white">System Settings (Coming Soon)</div>} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;